module.exports = __webpack_public_path__ + "img/voiced-and-deaf-consonants.4b8219a2.jpg";